import React from "react";

const hanthanaLifeImages = [
  "assets/images/hanthanalife/1.webp?v=20260924",
  "assets/images/hanthanalife/2.webp?v=20260924",
  "assets/images/hanthanalife/3.webp?v=20260924",
  "assets/images/hanthanalife/4.webp?v=20260924",
  "assets/images/hanthanalife/5.webp?v=20260924",
];

function HanthanaLife() {
  return (
    <section
      className="destination-three"
      style={{ backgroundColor: "#ffffff" }}
    >
      <div className="container">
        <div className="sec-title text-center">
          <h6 className="sec-title__tagline">Discover our lifestyle</h6>
          {/* /.sec-title__tagline */}
          <h3 className="sec-title__title">Hanthana Life</h3>
          {/* /.sec-title__title */}
        </div>
        {/* /.sec-title */}
        <div
          className="hanthana-life-gallery"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
            gap: "16px",
            flexWrap: "wrap",
            margin: "0 auto",
            maxWidth: "100%",
            paddingTop: "20px",
          }}
        >
          {hanthanaLifeImages.map((img, idx) => (
            <div
              className="item"
              key={idx}
              style={{
                flex: "0 1 160px",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                // Zigzag effect: even index up, odd index down
                transform: `translateY(${idx % 2 === 0 ? "-40px" : "40px"})`,
                transition: "transform 0.3s",
              }}
            >
              <a
                href="destination-details.html"
                className="destination-three__item"
                style={{ display: "block", width: "100%" }}
              >
                <img
                  src={img}
                  alt="villoz"
                  style={{
                    height: "240px",
                    width: "auto",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    display: "block",
                  }}
                />
              </a>
            </div>
          ))}
        </div>
        {/* /.row */}
      </div>
      {/* /.container */}
    </section>
  );
}

export default HanthanaLife;
